"use client";
import React, { useState } from "react";
import Image from "next/image";

import {
    SINGLE_SELECT_FILTERS,
    SLUGS_TO_IGNORE,
    FILTERS_HEADING,
} from "./constants";
import { Filterclose } from "@/public/Theme";
import FilterHeadingWithBackButton from "./FilterHeadingWithBackButton";
import { CheckboxFilterOption } from "./FilterTypes";
import TypographyLibre from "@/components/Atoms/TypographyLibre";
import ProductFilterDropdown from "./ProductFilterDropdown";
import { sizeMapping } from "@/lib/bigcommerce/restfull/helpers/constants";
import SizeCheckBox from "./SizeCheckBox";

const FilterOptions = ({
    setOpenFilter,
    setSelectedFilters,
    selectedFilters,
    setDrawerOpen,
    drawerOpen,
    filter,
}) => {
    const [region, setRegion] = useState(
        filter?.options && filter?.options[0]?.slug
    );
    let paramsNotToBeSelectedMultiple = selectedFilters?.filter(
        (filter) => !SINGLE_SELECT_FILTERS?.includes(filter?.key)
    );

    const [sortingSelectedOption, setSortingSelectedOption] = useState(
        filter?.options && filter?.options[0]
    );

    const [variantOptions, setVariantOptions] = useState(
        filter?.options && filter?.options[0] && filter?.options[0]?.values
    );

    const handleSize = (variantOption) => {
        setRegion(variantOption?.slug);
        setVariantOptions(variantOption?.values || []);
        setSortingSelectedOption(variantOption);
    };

    const getCorrespondingSizes = (selectedSize, region) => {
        // const sizeSplit = selectedSize?.split('-');
        // const matchedSize = sizeMapping.find((size) => size[region] === sizeSplit[1]);
        // if (!matchedSize) return [];

        return [{ key: "sizes", slug: selectedSize, region: region }];
        //** For the Resgion Size mapping ucomment this line */
        // return [
        //   { key: 'sizes', slug: 'US-' + matchedSize.US, region: 'US' },
        //   { key: 'sizes', slug: 'UK-' + matchedSize.UK, region: 'UK' },
        //   { key: 'sizes', slug: 'EU-' + matchedSize.EU, region: 'EU' },
        //   { key: 'sizes', slug: 'Standard-' + matchedSize.Standard, region: 'Standard' },
        // ];
    };

   

    const toggleSizeFilter = (option) => {
       

        const regionSizeMapping = getCorrespondingSizes(option?.value, region);

        

        // if only one option of the size exist then delete it
        const singleExist = selectedFilters.some(
            (item) => item.slug === option?.value
        );

        if (singleExist) {
            const updatedFilters = selectedFilters.filter(
                (item) => item.slug !== option?.value
            );

            setSelectedFilters(updatedFilters);
            return;
        }

        // This will work in cases of correspondance sizes
        const exists = regionSizeMapping.every((newItem) =>
            selectedFilters.some((filter) => filter.slug === newItem.slug)
        );

        let updatedFilters;
        if (!exists) {
            const combinedFilters = [...selectedFilters, ...regionSizeMapping];

            const uniqueFilters = Array.from(
                new Map(
                    combinedFilters.map((item) => [item.slug, item])
                ).values()
            );

            updatedFilters = uniqueFilters;
        } else {
            updatedFilters = selectedFilters.filter(
                (item) =>
                    !regionSizeMapping.some(
                        (newItem) => newItem.slug === item.slug
                    )
            );
        }

        setSelectedFilters(updatedFilters);
    };

    return (
        <>
            <div className="flex justify-center items-center gap-x-4">
                <TypographyLibre
                    align={"center"}
                    customStyle={"!text-xl sm:!text-2xl "}
                    fontWeight={"normal"}
                    text={FILTERS_HEADING}
                />

                <Image
                    width={24}
                    height={24}
                    className="cursor-pointer"
                    onClick={() => setDrawerOpen(!drawerOpen)}
                    src={Filterclose}
                    alt={"Black Cross _24x24"}
                />
            </div>

            <FilterHeadingWithBackButton
                filterName={filter?.name}
                setDrawerOpen={setDrawerOpen}
                onBackClick={() => setOpenFilter(null)}
            />
            <div className="mt-5 flex flex-col gap-y-3 min-h-[450px] max-h-[450px] overflow-y-auto">
                {filter?.key == "sizes" ? (
                    <>
                        {/* If the Filter is Size then show this  */}
                        <ProductFilterDropdown
                            width="w-full"
                            label={null}
                            options={filter?.options}
                            setSortingSelectedOption={handleSize}
                            sortingSelectedOption={sortingSelectedOption}
                        />
                        {/* options */}
                        {variantOptions?.map((option, index) => {
                            // Check if the filter is present in it or not
                            const checkObj = {
                                slug: option?.value,
                                key: "sizes",
                            };
                            const filterExists = selectedFilters?.some(
                                (item) =>
                                    item.slug === checkObj.slug &&
                                    item.key === checkObj.key &&
                                    item.slug.includes(region)
                            );

                            return (
                                <>
                                    <SizeCheckBox
                                        filterExists={filterExists}
                                        toggleSizeFilter={toggleSizeFilter}
                                        option={option}
                                    />
                                </>
                                // <CheckboxFilterOption
                                //     key={option?.value}
                                //     filterSelected={filterExists}
                                //     label={option?.label}
                                //     option={option}
                                //     toggleFilters={toggleSizeFilter}
                                //     filterType={
                                //         filter?.key === "colors" && "colors"
                                //     }
                                // />
                            );
                        })}
                    </>
                ) : (
                    filter?.options?.map((option, index) => {
                        if (
                            SLUGS_TO_IGNORE?.includes(String(option?.slug)) &&
                            filter?.key !== "collection"
                        )
                            return null;
                        let optionWithKey = {
                            slug: String(option?.slug),
                            key: filter?.key,
                        };
                        // check if this filter is selected
                        let filterSelected = JSON?.stringify(
                            selectedFilters
                        )?.includes(JSON?.stringify(optionWithKey));
                        // function to toggle filter selection
                        const toggleFilter = () => {
                            if (filterSelected) {
                                let updatedFilters = selectedFilters?.filter(
                                    (selectedFilter) =>
                                        selectedFilter?.slug !==
                                        String(option?.slug)
                                );
                                setSelectedFilters(updatedFilters);
                            } else {
                                let optionToUpdate =
                                    !SINGLE_SELECT_FILTERS?.includes(
                                        filter?.key
                                    )
                                        ? [...selectedFilters, optionWithKey]
                                        : [
                                              ...paramsNotToBeSelectedMultiple,
                                              optionWithKey,
                                          ];
                                setSelectedFilters(optionToUpdate);
                            }
                        };

                        return (
                            <div
                                key={index}
                                className="flex justify-between items-center cursor-pointer"
                            >
                                <CheckboxFilterOption
                                    filterSelected={filterSelected}
                                    label={option?.title || option}
                                    toggleFilters={toggleFilter}
                                    filterType={
                                        filter?.key === "colors" && "colors"
                                    }
                                />
                            </div>
                        );
                    })
                )}
            </div>
        </>
    );
};

export default FilterOptions;
